/* lua.js generated code 0.3.0 */

const ReplayDataFormatter = require("clover/data/Replay/ReplayDataFormatter")

CreateGameSceneLogic = xClass("CreateGameSceneLogic")
CreateGameSceneLogic.create = function (levelId, itemList, wantedId,loadLevelConfigCb) {
    return CreateGameSceneLogic.new(levelId, itemList, wantedId,loadLevelConfigCb)
}
CreateGameSceneLogic.prototype.ctor = function (levelId, itemList, wantedId,loadLevelConfigCb) {
    var self = this
    self.levelId = levelId
    self.levelType = LevelType.getLevelTypeByLevelId(levelId)
    //对传入道具排序,先神奇鸟再爆炸直线特效
    if (type(itemList) == "table") {
        table.sort(itemList, function (a, b) {
            return a < b
        })
    }
    self.itemList = itemList
    self.wantedId = null;   // 悬赏活动已删除
    self.otherData = {}
    self.adRefreshCount = null; // 关内广告使用道具次数，H5专用
    self.loadLevelConfigCb = loadLevelConfigCb

    // 百度防沉迷出第一次弹框后进对局记录
    if (window.mini && mini.getPlatform() == MiniPlatform.baidu){
        var sns = SnsProxy.getInstance();
        if (sns.antiAddictionTime){
            sns.setAntiAddictionHasEnterGame();
        }
    }
}
CreateGameSceneLogic.prototype.setOtherData = function (otherData = {}) {
    let self = this
    self.otherData = otherData
}
CreateGameSceneLogic.prototype.startGamePlayScene = function (finishCallback, onFail, actualLevelId) {
    var self = this
    // createGamePlayScene 放到 finishCallback 中执行
    self.loadLevelConfig(function (fileList) {
        if (finishCallback) {
            finishCallback(fileList)
        }
    }, onFail, actualLevelId)
}
/*     如果有id, score, 表明这是在跑check
 */
CreateGameSceneLogic.prototype.startReplayGamePlayScene = function (replayRecords, id, score, finishCallback) {
    var self = this
    // body
    function onLevelConfigLoadFinish(fileList) {
        cc.log(replayRecords);
        self.createReplayGamePlayScene(fileList, replayRecords, id, score)
        if (finishCallback) {
            finishCallback()
        }
    }
    // var levelConfig = LevelConfigManager.getInstance().getLevelConfigByID(self.levelId)
    // if (levelConfig) {
    self.loadLevelConfig(onLevelConfigLoadFinish)
    // } else {
    //     he_log_info("error: no map data for levelId = " + self.levelId)
    // }
}
// 获取攻略数据后，做成录像数据的样子用放录像的方法放攻略，新攻略的话已经有strategyContent是空的
CreateGameSceneLogic.prototype.startStrategyReplayGamePlayScene = function (levelId, fromAd = false, strategyId, strategyContent) {
    var self = this

    var success = function(evt){
        cc.log(evt);
        var info = JSON.parse(evt.data.content);
        self.formatter = new ReplayDataFormatter();
        var replay = self.formatter.unformat(info.replay)["1"];
        cc.log("===================replay===================", replay);

        var strategy = table();
        strategy["strategy"] = true;
        strategy["isOver"] = false;
        strategy["level"] = replay.level;
        strategy["randomSeed"] = replay.randomSeed;
        strategy["score"] = info.score;
        strategy["nickName"] = info.nickName;
        strategy["star"] = info.star;
        strategy["fromAd"] = fromAd;
        strategy["selectedItemsData"] = table();
        strategy["strategyId"] = strategyId;
        strategy["dropAdjustData"] = replay.dropAdjustData
        strategy["dropAdjustScheme"] = replay.dropAdjustScheme
        strategy["dropAdjustDataV2"] = replay.dropAdjustDataV2
        var replaySteps = replay.replaySteps;
        var steps = table();
        steps[0] = null;
        var i = 1;
        while(replaySteps[i] != undefined){
            steps[i] = table();
            steps[i]["x1"] = replaySteps[i]["x1"];
            steps[i]["x2"] = replaySteps[i]["x2"];
            steps[i]["y1"] = replaySteps[i]["y1"];
            steps[i]["y2"] = replaySteps[i]["y2"];
            i++;
        }
        strategy["replaySteps"] = steps;

        function onLevelConfigLoadFinish(fileList) {
            self.createReplayGamePlayScene(fileList, strategy, levelId, info.score);
        }
        self.loadLevelConfig(onLevelConfigLoadFinish)
    }

    var fail = function(errorCode){
        Toast.make(getText("error.tip." + errorCode.data));
    }
    
    if (fromAd){
        cc.log(strategyContent);
        cc.log(strategyContent == null, strategyContent == "", typeof(strategyContent) == "string");
        if (strategyContent == null || (typeof(strategyContent) == "string" && strategyContent == "")){
            var http = LevelStrategyWatchAdHttp.new();
            http.addEventListener(Events.kComplete, success);
            http.addEventListener(Events.kError, fail);
            http.addEventListener(Events.kCancel, fail);
            http.load(UserManager.getInstance().uid, levelId);
        }else{
            if (typeof(strategyContent) == "string"){
                var info = {data:{strategyId:strategyId, content:strategyContent}};
                success(info);
            }else{
                // 重播，这时候不需要转格式
                function onLevelConfigLoadFinish(fileList) {
                    self.createReplayGamePlayScene(fileList, strategyContent, levelId, strategyContent["score"]);
                }
                self.loadLevelConfig(onLevelConfigLoadFinish)
            }
        }
    }else{
        var http = ClickStrategyShareHttp.new();
        http.addEventListener(Events.kComplete, success);
        http.addEventListener(Events.kError, fail);
        http.addEventListener(Events.kCancel, fail);
        http.load(UserManager.getInstance().uid, strategyId, levelId);
    }
}

// function CreateGameSceneLogic:loadLevelConfig(onLoadFinish)
//     local levelConfig = LevelConfigManager:getInstance():getLevelConfigByID(self.levelId)
//     if levelConfig then
//         local fileList = levelConfig:getDependingSpecialAssetsList()
//         local musics = levelConfig:getNeedMusics()
//         -- local time = os.clock()
//         local loader = FrameLoader.new()
//         local function onFrameLoadComplete( evt )
//             loader:removeAllEventListeners()
//             -- print("add file in level spend time:")
//             -- print(os.clock() - time)
//             -- print("---------------------------")
//             -- debug.debug()
//             if onLoadFinish then onLoadFinish(fileList) end
//         end
//         for i,v in ipairs(fileList) do loader:add(v, kFrameLoaderType.plist) end
//         for i,v in ipairs(musics) do loader:add(v, kFrameLoaderType.mp3) end
//         loader:addEventListener(Events.kComplete, onFrameLoadComplete)
//         loader:load()
//     end
// end
CreateGameSceneLogic.prototype.loadLevelConfig = function (onLoadFinish, onFail, actualLevelId) {
    var self = this
    // body
    let loadLevelId = self.levelId
    if (actualLevelId)
        loadLevelId = actualLevelId
    
    if (self.mysteryIsland) loadLevelId = self.mysteryIsland.mainLevelId
    let cnt = 0
    let checkScores = (fileList)=>{
        cnt++
        if (cnt > 3){
            onLoadFinish && onLoadFinish()
            window.logCenter && logCenter.error(new Error(`CreateGameSceneLogic loadLevelConfig checkScores  fail loadLevelId${loadLevelId}`, 'ScoresError'))
            return
        }
        let scores = UserManager.getInstance().getScoreRef()
        if (LevelType.isMainLevel(self.levelId) && !scores[self.levelId]){
            UserManager.getInstance().updateScoreRef([self.levelId]).then(()=>{
                onLoadFinish && onLoadFinish(fileList)
            }).catch(() => {
                checkScores(fileList)
            })
        }else{
            onLoadFinish && onLoadFinish(fileList)
        }
    }
    let isLoadLoading = null
    if(self.levelType == GameLevelType.kPvp){
        isLoadLoading = GameResLoad.getInstance().startPvp(loadLevelId,checkScores, onFail,{
            otherData: self.otherData,
            levelType: self.levelType
        })
    }else{
        isLoadLoading = GameResLoad.getInstance().start(loadLevelId,checkScores, onFail,{
            otherData: self.otherData,
            levelType: self.levelType
        })
    }
    
    this.loadLevelConfigCb && this.loadLevelConfigCb(isLoadLoading)

    if (isLoadLoading ){
        var runningScene = cc.Director.getInstance().getRunningScene()
        let runSceneMethod = 'push'
        if (runningScene) {
            if (runningScene.name === "LevelLoadingScene") {
                return false
            } else if (runningScene.name !== "HomeScene") {
                runSceneMethod = "replace";
            }
            if (runningScene.name === "GameScene" || runningScene.name == "ReplayGameScene") {
                runningScene.notUninstallRes = true
            }
        }
        function finish() {
            if (checkScores) {
                checkScores()
            }
        }
        var scene = require("clover/scene/LevelLoadingScene").create(null, finish, loadLevelId, {})
        cc.Director.getInstance()[`${runSceneMethod}Scene`](scene)
    }

    // let lvResPath = LevelConfigManager.getInstance().getLevelConfigPath(loadLevelId,self.mysteryIsland);

    // let resList = [lvResPath];
    // ["meta/game_map_res.json", "meta/game_guide_res.json"].forEach(v=> {
    //     if (!cc.loader.getRes(v))
    //         resList.push(v);
    // }); 
    // cc.loader.load(resList, function (error) {
    //     if (error) {
    //         if (onFail && type(onFail) === "function") {
    //             onFail()
    //         }else {
    //             Toast.make(curryQuickGetErrorText(0))
    //         }
    //         return
    //     }
    //     let MapResConfig = require("clover/config/level/MapResConfig")
    //     MapResConfig.load();
        
                // fileList = fileList.concat(["packed/ChallengeActivityRes.pack"])
    //     var levelConfig = LevelConfigManager.getInstance().getLevelConfigByID(loadLevelId, null, self.otherData);
    //     unloadResList(lvResPath);
    //     if (levelConfig) {
    //         if (actualLevelId){
    //             LevelConfigManager.getInstance().replaceLevelID(actualLevelId, self.levelId)
    //         }
    //         if (self.levelType === GameLevelType.kPvp && self.otherData && self.otherData.randomSeed) {
    //             levelConfig.randomSeed = self.otherData.randomSeed
    //         }
    //         var fileList = levelConfig.getDependingSpecialAssetsList(null, self.otherData)[0]
    //         var prefillAnis = levelConfig.getDependingSpecialAssetsList(null, self.otherData)[1]
    //         if (self.otherData && self.otherData.contestUid) {
    //             // cc.log("------------- challenge res -------------------")
    //             fileList = fileList.concat(ActivityRes.ChallengeActivity)
    //         }
            
    //         if(self.levelType == GameLevelType.kPvp){
    //             // 友谊赛
    //             fileList = fileList.concat([
    //                 "cocos/level.plist"
    //             ])
    //         }
    //         // 如果是神秘岛关卡增加 动画资源
    //         if(self.levelType == GameLevelType.kMysteryIsland){
    //             _G.RunningGameLevelType = GameLevelType.kMysteryIsland
    //             fileList = fileList.concat([
    //                 "packed/MysteryIsland.pack",
    //                 "packed/BaseBowknotAssets.pack",//其中一种动画用到了蝴蝶资源需要加载
    //                 "cocos/boss_common_res.plist"
    //             ])
    //         }else{
    //             // 这个变量目前只有神秘岛在用这里 保证和原来一致
    //             _G.RunningGameLevelType = null
    //         }
    //         // 判断是否播放紫咪动画 播放加入紫咪动画资源
    //         if (self.actPreProp && self.actPreProp.purpleAmyMagic && self.actPreProp.purpleAmyMagic.props 
    //             && $len(self.actPreProp.purpleAmyMagic.props)>0){
    //                 fileList = fileList.concat([
    //                     "packed/PurpleAmyMagicPropAnim.pack"
    //                 ])
    //         }
           
    //         // 判断是否在晋级赛
    //         fileList = fileList.concat([
    //             "packed/QualifyGame.pack"
    //         ])
    //         if(QualifyGameManager.getInstance().isQualifyOpenWithLevelID(self.levelId)){
    //         }
    //         fileList = fileList.concat([
    //             "packed/PurpleAmyMagicMain.pack"
    //         ])
    //         var musics = levelConfig.getNeedMusics()
    //         var resource = table([1, "kPlist", fileList], [1, "kMusics", musics], [1, "kPrefillPool", prefillAnis])
    //         var runningScene = cc.Director.getInstance().getRunningScene()
    //         let runSceneMethod = 'push'
    //         if (runningScene) {
    //             if (runningScene.name === "LevelLoadingScene") {
    //                 return false
    //             } else if (runningScene.name !== "HomeScene") {
    //                 runSceneMethod = "replace";
    //             }
    //         }
    //         function finish() {
    //             if (onLoadFinish) {
    //                 onLoadFinish(fileList)
    //             }
    //         }
    //         var scene = require("clover/scene/LevelLoadingScene").create(resource, finish, loadLevelId, self.otherData)
    //         cc.Director.getInstance()[`${runSceneMethod}Scene`](scene)
    //         // scene.run()
    //     } else {
    //         Toast.make(tostring(self.levelId) + "关卡不存在！！！")
    //     }
    // })
}
CreateGameSceneLogic.prototype.createGamePlayScene = function (fileList, isWeekGame=false) {
    var self = this
    console.log("@@@@create game play scene")
    function waitingResCallback() {
        let HomeScene = require("clover/scene/HomeScene")
        let homeSceneInstance = HomeScene.getHomeScene()
        if (homeSceneInstance){
            homeSceneInstance.releasMiniSceneTex()
        }
        var runningScene = cc.Director.getInstance().getRunningScene()
        if (runningScene ) {//&& (runningScene.getName() === "LevelLoadingScene")
            // cc.Director.getInstance().popScene()
            require.ensure([], () => {
                let gameScene = require("clover/scene/GameScene").create();
                gameScene.loadLevel(self.levelId, self.levelType, self.itemList, fileList, self.otherData, self.mysteryIsland,self.actPreProp,self.levelCollectType).run();
                gameScene.setAdRefreshCount(self.adRefreshCount);
                // 打点关前广告道具的获取和消耗
                if (self.adPropIds){
                    let adPropIdArr = table()
                    // 打点需要模拟数据
                    for (let i = 0; i < self.adPropIds.length; i++) {
                        let adprop = self.adPropIds[i]
                        table.insert(adPropIdArr, {itemId:adprop,num:1});
                    }
                    adPropIdArr.forEach(adprop => {
                        if (adprop){
                            DCAssist.dc4GetThings(adprop.itemId, adprop.num, "getitems_ad", {session: DCAssist.playLevelSession, item_worth:"ad"})
                        }
                    })
                    DCAssist.dc4UseThings(adPropIdArr, "stage_start", null, {});
                }
                if (self.adStartItmesDc){
                    self.adStartItmesDc.forEach(adprop => {
                        if (adprop){
                            DCAssist.dc4GetThings(adprop.itemId, adprop.num, "bef_stage_ad", {session: DCAssist.playLevelSession, item_worth:"ad"})
                        }
                    })
                    DCAssist.dc4UseThings(self.adStartItmesDc, "stage_start", null, {});

                }
                // if (self.itemList){
                //     let dcArr = table()
                //     for (let i = 1; i <= $len(self.itemList); i++) {
                //         table.insert(dcArr,{
                //             itemId: self.itemList[i],
                //             num: 1
                //         })
                //     }
                //     DCAssist.dc4UseThings(dcArr, "stage_start", null, {})
                // }
                let initPropsList = table()
                if (self.initProps){
                    for (var i = 1, v = self.initProps[1]; v; i++, v = self.initProps[i]) {
                        if(!UserPropData.isLitmitedPreProp(v)) {
                            table.insert(initPropsList, v)
                        } else {
                            //getAndUpdateTimeProps会把过期的销毁,导致consumeProp前端会再次扣除未过期的。
                            if(self.litmitedProps && self.litmitedProps[v] && self.litmitedProps[v] <= UserManager.getInstance().getUserTimePropNumber(v)) {
                                UserManager.getInstance().useTimeProp(v);
                            } else {
                                //
                                console.log("user prop", v);
                            }
                            let pArr = table()
                            table.insert(pArr, {itemId: v, num: 1})
                            DCAssist.dc4UseThings(pArr, ModuleName.BEFORE_STAGE, {level:self.levelId}, UserManager.getInstance().getUserTimePropNumber(v) + 1)
                        }
                    }
                    if ($len(initPropsList) > 0) {
                        UserProp.getInstance().useProp(initPropsList, self.levelId, null, null, null, null, ModuleName.BEFORE_STAGE ,false)
                    }
                }
                if (self.dcOtherUseProps){
                    let pArr = table()
                    for (let i = 1; i <= $len(self.dcOtherUseProps); i++) {
                        table.insert(pArr, {itemId: self.dcOtherUseProps[i], num: 1})
                    }
                    DCAssist.dc4UseThings(pArr, ModuleName.BEFORE_STAGE, {level:self.levelId}, UserManager.getInstance().getUserTimePropNumber(v) + 1)
                }
                dc4UserLoad(120)
            }, null, 'game')
        }
    }
    AsyncLoader.getInstance().waitingForLoadComplete(waitingResCallback)
}
CreateGameSceneLogic.prototype.createReplayGamePlayScene = function (fileList, replayRecords, clientId, score, strategyfromAd) {
    var self = this
    
    console.log("@@@@create replay game play scene")
    var strategyfromAd = false; // 只有从点广告来的攻略有用
    if (replayRecords.fromAd){
        strategyfromAd = replayRecords.fromAd;
    }
    // 恢复关卡从记录里取难度
    UserTagData.getInstance().refreshOrthByStartLevel(replayRecords.payNum || 0, replayRecords.pdiff || 0, replayRecords.ndiff || 0, replayRecords.completeExpect || 0);
    // body
    function waitingResCallback() {
        let HomeScene = require("clover/scene/HomeScene")
        let homeSceneInstance = HomeScene.getHomeScene()
        if (homeSceneInstance){
            homeSceneInstance.releasMiniSceneTex()
        }
        var runningScene = cc.Director.getInstance().getRunningScene()
        if (runningScene && (runningScene.getName() === "LevelLoadingScene")) {
            require.ensure([], () => {
                var scene = require("clover/scene/ReplayGameScene").create()
                scene.setCheckInfo(clientId, score)
                scene.loadLevel(self.levelId, self.levelType, fileList, replayRecords, self.otherData, self.mysteryIsland,self.levelCollectType)
                scene.setAdRefreshCount(self.adRefreshCount);
                scene.run()
                if (strategyfromAd){
                    scene.setStrategyFromAd();
                }
            }, null, 'game')
        }
    }
    AsyncLoader.getInstance().waitingForLoadComplete(waitingResCallback)
}
CreateGameSceneLogic.prototype.getPlayGameData = function () {
    let self = this
    let data = {}
    data.id = self.levelId
    data.levelType = self.levelType
    data.extraData = self.otherData
    data.itemList = clone(self.itemList)
    data.mysteryIsland = self.mysteryIsland
    return data 
}
CreateGameSceneLogic.prototype.setMysteryIsland = function (value) {
    let self = this
    // body
    self.mysteryIsland = value
}

CreateGameSceneLogic.prototype.setActPreProp = function (value) {
    let self = this
    // body
    self.actPreProp = value
}
CreateGameSceneLogic.prototype.setLevelCollectType = function (value) {
    let self = this
    // body
    cc.log("CreateGameSceneLogic setLevelCollectType ",value)
    self.levelCollectType = value ? value : 0
}
CreateGameSceneLogic.prototype.setAdPropIds = function (value) {
    let self = this
    cc.log("CreateGameSceneLogic setAdPropIds ",value)
    // body
    self.adPropIds = value
}
CreateGameSceneLogic.prototype.setAdStartItmesDc = function (value) {
    let self = this
    cc.log("CreateGameSceneLogic setAdStartItmesDc ",value)
    // body
    self.adStartItmesDc = value
}
CreateGameSceneLogic.prototype.setStartLogicData = function (data) {
    let self = this
    cc.log("CreateGameSceneLogic setStartLogicData ",data)
    self.initProps = data.initProps
    self.litmitedProps = data.litmitedProps
    self.dcOtherUseProps = data.dcOtherUseProps
}
